import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import ASCButton from "../Button";

function DeleteDependencyPopup(props: any) {
  return (
    <Dialog open={props.dependencyDeletePopup}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Unable to Delete</DialogTitle>
          <DialogContent>{props.dependencymessage}</DialogContent>
          <DialogActions>
            <ASCButton
              shape="rounded"
              className="asc-button-primary"
              appearance="primary"
              onClick={() =>
                props.onClose
                  ? props.onClose()
                  : props.setDependencyDeletePopup(false)
              }
              label="Close"
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default DeleteDependencyPopup;
